import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"
import { projectFormSubmitterViewStaticData } from "src/views/ProjectSubmitFormView/constants"
import { ProjectSubmitFormView } from "src/views/ProjectSubmitFormView/ProjectSubmitFormView"
import * as z from "zod"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/$formId/submit",
)({
	component: ProjectSubmitFormView,
	staticData: projectFormSubmitterViewStaticData,
	validateSearch: zodValidator(
		z.object({
			asset: z.string().optional(),
			issue: z.string().optional(),
		}),
	),
})
